export const getLatLngFromPointGeomCoordinates = (geom:{
    type:'Point',
    coordinates:[lng:number,lat:number]
}):{
    lat:number,
    lng:number
}=>{
    if(geom?.type !== 'Point'){
        return  {
            lat:0,
            lng:0
        }
    }
    if(geom?.coordinates?.length <2){
        return  {
            lat:0,
            lng:0
        }
    }
    return {
        lat:geom.coordinates[1],
        lng:geom.coordinates[0],
    }
}
